import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Database, Brain, TrendingUp } from 'lucide-react';

const DataAnalytics = () => {
  const services = [
    {
      icon: <Database size={40} />,
      title: 'Big Data Engineering',
      description: 'Build scalable data pipelines and modern data architectures for enterprise-scale analytics.',
      features: ['Data lake architecture', 'ETL/ELT pipelines', 'Real-time processing', 'Data governance']
    },
    {
      icon: <BarChart3 size={40} />,
      title: 'Business Intelligence',
      description: 'Transform raw data into actionable insights with advanced BI and visualization tools.',
      features: ['Interactive dashboards', 'Self-service analytics', 'Automated reporting', 'KPI monitoring']
    },
    {
      icon: <Brain size={40} />,
      title: 'Advanced Analytics',
      description: 'Leverage machine learning and AI for predictive analytics and intelligent automation.',
      features: ['Predictive modeling', 'Machine learning', 'Statistical analysis', 'Pattern recognition']
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Data Strategy',
      description: 'Develop comprehensive data strategies aligned with business objectives and growth goals.',
      features: ['Data roadmap', 'ROI optimization', 'Change management', 'Skills development']
    }
  ];

  return (
    <div className="service-page">
      <div className="container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Data & Analytics Services</h1>
          <p>Unlock the power of your data with advanced analytics and business intelligence solutions.</p>
        </motion.div>

        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul>
                {service.features.map((feature, idx) => (
                  <li key={idx}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataAnalytics;